const related = {
  // ===== 共通(関連事業ページの本文は src/data/related/ja.ts に移設・2026-09-18) =====
  'related.common.official': '公式サイトを見る',
  'related.common.externalNote': '※リンク先は別サイトです（別ウィンドウで開きます）',
  'related.common.backToHub': '関連事業の一覧へ戻る',
  'related.common.backToTop': 'ページ上部へ戻る',
  'related.common.otherTitle': 'ほかの関連事業',
  'related.common.otherSubtitleEn': 'Other related organizations',
};

export default related;
